module.exports = __webpack_public_path__ + "static/media/tier-6.f434c777.jpg";